<template>
  <div>
    <label>Output file name:</label>
    <b-form-input v-model="options.fileName"></b-form-input>

    <label>Output file type:</label>
    <b-form-select
      v-model="options.fileType"
      :options="fileTypeOptions"
    ></b-form-select>
  </div>
</template>

<script>
import { Vue } from 'vue-property-decorator'; // Import Vue from 'vue' instead of 'vue-property-decorator'
import { DefaultOptions, fileTypeOptions } from "../types";

export default {
  props: {
    options: Object // Define options prop without decorators
  },
  data() {
    return {
      fileTypeOptions: fileTypeOptions
    };
  }
}
</script>